<template>
  <v-menu
    offset-y
    origin="center center"
    class="elevation-1 c-button-menu"
    :nudge-bottom="14"
    transition="slide-y-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn text class="c-button-toolbar" v-on="on">
        <v-badge color="red" overlap>
          <span slot="badge">{{ unreadCount }}</span>
          <v-icon color="opposite" medium>notifications</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card class="elevation-0" color="opposite">
      <v-card-title dense>
        <h4>
          {{ generateMessage('boilerplate.notifications.title') }}
        </h4>
        <v-switch
          v-model="displayUnreadItems"
          class="ml-5"
          @click.stop
          label="Uniquement les non lues"
        />
        <div class="pl-6">
          <v-btn icon @click.stop="refreshCountNotifications()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-progress-linear indeterminate v-if="isLoading" />
      <v-card-text class="pa-0">
        <v-list two-line class="pa-0 menu-list">
          <template v-for="(item, index) in filteredItems">
            <v-list-item :key="index">
              <v-icon class="mr-2" color="primary">
                {{ item.icon || 'person' }}
              </v-icon>
              <v-list-item-content
                @click.stop="handleClick(item)"
                :class="{ 'lightgrey--text': item.read === 'O' }"
              >
                <v-list-item-title class="text-caption">
                  {{ item.message_datetime }}
                  <v-icon
                    x-small
                    class="float-right"
                    color="primary"
                    v-if="item.read === 'N'"
                  >
                    fiber_manual_record
                  </v-icon>
                </v-list-item-title>
                <v-list-item-subtitle
                  :class="{ clickable: item.link }"
                  @click="goTo(item.link)"
                >
                  <span class="font-weight-bold">{{ item.topic_name }}</span>
                  <truncate-text-with-hover
                    :class="{ 'lightgrey--text': item.read === 'O' }"
                    :text="item.message"
                    :length="30"
                  />
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
        <v-divider></v-divider>
        <v-btn block text class="ma-0">All</v-btn>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import {
  getNotifications,
  getUnreadNotifications,
  getCountNotifications,
  checkNotifications,
} from '@/services/services/notifications.service';
import { generateMessage } from '@/utils/i18n';
import TruncateTextWithHover from '@/components/tools/TruncateTextWithHover';

const REFRESH_DELAY = 3600 * 1000;

export default {
  data: () => ({
    items: [],
    unreadItems: [],
    displayUnreadItems: true,
    unreadCount: 0,
    isLoading: false,
    countInterval: null,
    newCountNotifications: false,
  }),
  components: {
    TruncateTextWithHover,
  },
  props: {
    count: {
      type: Number,
    },
  },
  computed: {
    filteredItems() {
      return !this.displayUnreadItems ? this.items : this.unreadItems;
    },
  },
  methods: {
    generateMessage,
    handleClick(item) {
      checkNotifications(item.message_id, item.read === 'O').then(() => {
        this.refreshCountNotifications();
      });
    },
    goTo(link) {
      if (link) {
        const route = JSON.parse(link);
        this.$router.push(route);
      }
    },
    async refreshNotifications() {
      await getNotifications().then((res) => {
        this.items = res.map((item) => ({
          ...item,
          message_datetime: new Date(item.message_datetime).toLocaleString(),
        }));
      });
    },
    async refreshUnreadNotifications() {
      await getUnreadNotifications().then((res) => {
        this.unreadItems = res.map((item) => ({
          ...item,
          message_datetime: new Date(item.message_datetime).toLocaleString(),
        }));
      });
    },
    async refreshCountNotifications() {
      clearTimeout(this.countInterval);
      this.isLoading = true;
      await getCountNotifications()
        .then(async (res) => {
          this.unreadCount = res;
          await this.refreshNotifications();
          await this.refreshUnreadNotifications();
        })
        .finally(() => {
          this.isLoading = false;
        });
      this.countInterval = setTimeout(() => {
        this.refreshCountNotifications();
      }, REFRESH_DELAY);
    },
  },
  mounted() {
    this.refreshCountNotifications();
  },
  destroyed() {
    clearTimeout(this.countInterval);
  },
};
</script>

<style scoped>
.menu-list {
  max-height: 70vh;
  overflow-y: auto;
}
.bordered {
  border: 1px solid #7f7f7f;
}

.clickable {
  cursor: pointer;
}
</style>
